import '../styles/style.scss'
import Scene from './scene'

Scene.init()

// Target width used when resizing the image (and generating particles)
let targetWidth = 320
let currentImg = null

const resolutionRange = document.getElementById('resolutionRange')
const resolutionValue = document.getElementById('resolutionValue')

function resizeImage(img, width = targetWidth) {
    const ratio = img.width / img.height
    const targetHeight = Math.round(width / ratio)

    const canvas = document.createElement('canvas')
    canvas.width = width
    canvas.height = targetHeight

    const ctx = canvas.getContext('2d')
    ctx.drawImage(img, 0, 0, width, targetHeight)

    const resizedImg = new Image()
    resizedImg.src = canvas.toDataURL()
    return resizedImg
}

function loadImage(img) {
    currentImg = img

    const resized = resizeImage(img)
    resized.onload = () => {
        Scene.world.setImage(resized)
    }
}

function updateTargetWidth(width) {
    targetWidth = Number(width)
    resolutionValue.textContent = targetWidth

    if (!currentImg) return

    const resized = resizeImage(currentImg, targetWidth)

    resized.onload = () => {
        Scene.world.setImage(resized)
    }
}

if (resolutionRange && resolutionValue) {
    resolutionValue.textContent = targetWidth
    resolutionRange.addEventListener('input', (event) => {
        updateTargetWidth(event.target.value)
    })
}

// Handle gallery image selection
const imageCards = document.querySelectorAll('.sidebar__grid--item')
imageCards.forEach(card => {
    card.addEventListener('click', () => {
        imageCards.forEach(c => c.classList.remove('active'))
        card.classList.add('active')
        
        // Get the image src from the card's img element
        const imgElement = card.querySelector('img')
        if (imgElement) {
            const img = new Image()
            img.onload = () => loadImage(img)
            img.src = imgElement.src
        }
    })
})

const initialCard = document.querySelector('.sidebar__grid--item.active') || imageCards[0]
if (initialCard) {
    const imgElement = initialCard.querySelector('img')
    if (imgElement) {
        const img = new Image()
        img.onload = () => loadImage(img)
        img.src = imgElement.src
    }
}

// Handle sidebar upload
const imageUploadSidebar = document.getElementById('upload')
imageUploadSidebar.addEventListener('change', (event) => {
    const file = event.target.files[0]
    if (file) {
        const reader = new FileReader()
        reader.onload = (e) => {
            const img = new Image()
            img.onload = () => {
                // Remove active class from gallery cards
                imageCards.forEach(c => c.classList.remove('active'))
                loadImage(img)
            }
            img.src = e.target.result
        }
        reader.readAsDataURL(file)
    }
})

// Handle sidebar toggle
const sidebar = document.querySelector('.sidebar')
const sidebarToggle = document.querySelector('.toggle')
sidebarToggle.addEventListener('click', () => {
    sidebar.classList.toggle('hide')
    sidebarToggle.classList.toggle('closed')
})